import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Anonymous page-visit tracker. Fires a POST to /api/track on every route change.
 * Skips /admin paths (owner traffic) so the stats reflect real user activity only.
 */
export default function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    // Fire and forget; never block or surface errors to the user
    api.post("/track", {
      path: location.pathname,
      referrer: document.referrer || null,
    }).catch(() => {});
  }, [location.pathname]);
  return null;
}
